var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 50,
    viewBox: "0 0 27 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1,
    d: "M26.372 23.628L3.284.54a1.924 1.924 0 00-2.72 2.72L22.29 24.989.563 46.716a1.924 1.924 0 002.72 2.72L26.373 26.35a1.924 1.924 0 000-2.72z"
  })));
};
export default SvgArrow;